<template>
  <page-header-wrapper>
    <div slot="extra">
      <router-link v-action:add :to="{ path: '/admins/roles/form' }">
        <a-button type="primary" icon="plus">
          添加角色
        </a-button>
      </router-link>
    </div>
    <a-card :bordered="false" :loading="spinning">
      <a-tree :treeData="treeData">
        <template slot="custom" slot-scope="item">
          <span>{{ item.name }}</span>
          <template v-if="item.slug !== 'admin'">
            <span class="d-flex">
              <router-link v-action:update :to="{ path: '/admins/roles/form/' + item.id }">
                <a-button type="link" size="small" class="but_type">编辑</a-button>
              </router-link>
              <a-button
                type="link"
                size="small"
                v-action:delete
                class="but_type"
                @click="e => remove(item.id)"
              >删除</a-button
              >
            </span>
          </template>
        </template>
      </a-tree>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { Tree, Pagination } from 'ant-design-vue'
// import ModelForm from './modules/ModelForm'
import { requestDelete, requestGet } from '@/api/api'

export default {
    name: 'RolesList',
    components: {
        // ModelForm,
        ATree: Tree,
        APagination: Pagination
    },
    data () {
        return {
            treeData: null,
            spinning: false
        }
    },
    mounted () {
        this.getLists() // 获取列表
    },
    methods: {
        getLists () {
            this.spinning = true
            requestGet('/admins/roles')
                .then(res => {
                    const pagination = { ...this.pagination }
                    const { result } = res
                    result.data.filter(item => {
                        item.scopedSlots = { title: 'custom' }
                    })
                    this.pageSizeChange = false
                    pagination.total = result.paginate.total
                    pagination.pageSize = result.paginate.perpage
                    this.pagination = pagination
                    this.treeData = result.data
                })
                .catch(err => console.log(err))
                .finally(() => {
                    this.spinning = false
                })
        },
        // append (data) {
        //     // 添加
        //     const that = this
        //     that.$dialog(
        //         ModelForm,
        //         {
        //             on: {
        //                 ok () {
        //                     that.getLists()
        //                 }
        //             }
        //         },
        //         {
        //             title: '角色管理',
        //             centered: true,
        //             width: 700,
        //             okText: '提交',
        //             cancelText: '关闭',
        //             maskClosable: false
        //         }
        //     )
        // },
        remove (id) {
            const that = this
            that.spinning = true
            requestDelete('/admins/roles/' + id)
                .then(res => {
                    this.getLists()
                })
                .finally(() => {
                    that.spinning = false
                })
        }
        // edit (aid) {
        //     const that = this
        //     that.$dialog(
        //         ModelForm,
        //         {
        //             aid,
        //             on: {
        //                 ok () {
        //                     that.getLists()
        //                 }
        //             }
        //         },
        //         {
        //             title: '编辑角色',
        //             centered: true,
        //             width: 700,
        //             okText: '提交',
        //             cancelText: '关闭',
        //             maskClosable: false
        //         }
        //     )
        // }
    }
}
</script>

<style lang="less" scoped>
/deep/.ant-tree-title {
    width: 100%;
    display: flex;
    justify-content: space-between;
}
/deep/.ant-tree li .ant-tree-node-content-wrapper {
    width: calc(100% - 24px);
}
.ant-card-body {
    :global {
        .ant-tree {
            line-height: 3;
            li {
                position: relative;
            }
        }
    }
}
.ant-card-body .but_type {
    right: 40px;
}
</style>
